import React from 'react'
import formatMessage from 'format-message'

export default function Loading() {
  return (
    <div id="loading-container">
      <div className="absolute-center">
        <div title={formatMessage('Loading')} className="InstUISpinner InstUISpinner--medium">
          <svg
            className="InstUISpinner-svg"
            role="img"
            aria-labelledby="InstUISpinner-5otot"
            focusable="false"
          >
            <title id="InstUISpinner-5otot">{formatMessage('Loading')}</title>
            <g role="presentation">
              <circle className="InstUISpinner-circleShadow" cx="50%" cy="50%" r="1.75em" />
              <circle className="InstUISpinner-circleTrack" cx="50%" cy="50%" r="1.75em" />
              <circle className="InstUISpinner-circleSpin" cx="50%" cy="50%" r="1.75em" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  )
}
